import actionCreatorFactory from 'typescript-fsa';
const actionCreator = actionCreatorFactory();
export default actionCreator<{}>('TENANT/EDIT/CANCEL');
